import { useCookie } from 'nuxt/app'

export function useACookie() {
  // COOKIE VALUES
  const appThemeCookie = useCookie<string>('appTheme', {
    default: () => 'system',
  });

  const systemThemeCookie = useCookie<string>('systemTheme', {
    default: () => 'light',
  });

  const authToken = useCookie<string | null>('authToken', {
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
    maxAge: 60 * 60 * 24 * 7,
    default: () => null,
  })

  // SET COOKIES
  const setAppTheme = (value: string) => {
    appThemeCookie.value = value;
    return value;
  };

  const setSystemTheme = (value: string) => {
    systemThemeCookie.value = value;
    return value;
  };

  const setAuthToken = (v: string | null) => { authToken.value = v }

  // EXPORT COOKIES & FUNCTIONS
  return { appThemeCookie, systemThemeCookie, authToken, setAppTheme, setSystemTheme, setAuthToken }
}